import React from 'react';
import styled from 'styled-components';

interface NotificationProps {
  id: number;
  service: string;
  date: string;
  message: string;
  type: 'info' | 'warning' | 'alert';
  linkText?: string;
  linkUrl?: string;
}

const notifications: NotificationProps[] = [
  {
    id: 1,
    service: 'IAM',
    date: 'Feb 27, 2025',
    message: 'Your Users data export is ready to download.',
    type: 'info',
    linkText: 'download',
    linkUrl: '#',
  },
  {
    id: 2,
    service: 'Enterprise Communication Service',
    date: 'Feb 25, 2025',
    message: '3 email notifications bounced due to invalid email address.',
    type: 'warning',
    linkText: 'View details',
    linkUrl: '#',
  },
  {
    id: 3,
    service: 'Messaging Service',
    date: 'Feb 19, 2025',
    message:
      'Upcoming Apache Pulsar scheduled maintenance window March 3, 2025, 9pm-11pm CST.',
    type: 'alert',
  },
  {
    id: 4,
    service: 'IAM',
    date: 'Feb 12, 2025',
    message:
      'Your request to join the Optum Pro Account is approved with an Account Contributor role.',
    type: 'info',
    linkText: 'Optum Pro Account',
    linkUrl: '#',
  },
];

interface NotificationProps {
  id: number;
  service: string;
  date: string;
  message: string;
  type: 'info' | 'warning' | 'alert';
  linkText?: string;
  linkUrl?: string;
}

interface NotificationsContainerProps {
  color: string;
  fontFamily: string;
  backgroundColor: string;
  height: number;
}
const NotificationsContainer = styled.div<NotificationsContainerProps>`
  top: ${props => props.height}px;
  padding: 20px;
  border-radius: 8px;
  width: 600px;
  position: absolute;
  background-color: ${props => props.backgroundColor};
  color: ${props => props.color};
  font-family: ${props => props.fontFamily};
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  right: -5px;
  z-index: 999;
`;

const NotificationCard = styled.div<{ type: 'info' | 'warning' | 'alert' }>`
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: background-color 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-left: 4px solid
    ${props =>
      props.type === 'info'
        ? '#ff9800'
        : props.type === 'warning'
        ? '#ffeb3b'
        : '#f44336'};
`;

const NotificationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
`;

const NotificationBody = styled.div`
  margin-top: 5px;
`;

const ClearAllButton = styled.button`
  background-color: #ff9800;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  width: 100%;
`;

const NotificationLink = styled.a`
  color: #ff9800;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

// Notification Component
const Notification: React.FC<NotificationProps> = ({
  service,
  date,
  message,
  type,
  linkText,
  linkUrl,
}) => {
  return (
    <NotificationCard type={type}>
      <NotificationHeader>
        <span>{service}</span>
        <span>{date}</span>
      </NotificationHeader>
      <NotificationBody>
        <p>
          {message}{' '}
          {linkText && linkUrl && (
            <NotificationLink href={linkUrl}>{linkText}</NotificationLink>
          )}
        </p>
      </NotificationBody>
    </NotificationCard>
  );
};

// Notifications Component
const Notifications: React.FC<{
  color: string;
  fontFamily: string;
  backgroundColor: string;
  height?: number;
}> = ({ color, fontFamily, backgroundColor, height }) => {
  return (
    <NotificationsContainer
      color={color}
      fontFamily={fontFamily}
      height={height}
      backgroundColor={backgroundColor}
    >
      {notifications.map(notification => (
        <Notification key={notification.id} {...notification} />
      ))}
      <ClearAllButton>Clear All</ClearAllButton>
    </NotificationsContainer>
  );
};

export default Notifications;
